module.exports = __webpack_public_path__ + "static/img/document.98df5c1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/document.gif
// module id = 3DU4
// module chunks = 1